module.exports = __webpack_public_path__ + "static/media/hood-cloak.50db2b08.svg";